import accountServices from '../../../services/account'
import { Auth } from 'aws-amplify'
import { AmplifyEventBus } from 'aws-amplify-vue'
import {signIn} from '@/utils/auth.js'
import {signOut} from '@/utils/auth.js'
export default {
    name: "SignIn",
    data() {
        return {
            payload: {},
            isUserConfirmed:false
        }
    },
    created(){
        if (this.$route && this.$route.query.e) {
            this.payload = {
                //token: this.$route.query.c,
                email: this.$route.query.e,
                code: this.$route.query.y,
                password: null,
                confirm_password: null,
            }
            // this.ConfirmCode()
            // signIn(this.payload.email, 'Temp@321')
        } else {            
            this.$router.push({name: 'Login'})
        }
    },
    methods: {
        ConfirmCode() {
            Auth.confirmSignUp(this.payload.email, this.payload.code).then(data => {
                AmplifyEventBus.$emit('authState', 'signIn')
                return data // 'SUCCESS'
              })
                .catch(err => {
                    debugger
                    if(err.message == "User cannot be confirmed. Current status is CONFIRMED")
                    {
                        this.isUserConfirmed = true
                    }
                    
                //   console.log(err);
                //   throw err;
                });
        },
        getUser() {
            return Auth.currentAuthenticatedUser().then((user) => {
              if (user && user.signInUserSession) {
                return user
              } else {
                return null
              }
            }).catch(err => {
            //   console.log(err);
            //   return null;
            });
          },
        UpdatePassword() {
            if(!this.isUserConfirmed)
            {
                debugger
                this.ConfirmCode()
                debugger
                signIn(this.payload.email, 'Temp@321').then(user => {
                    debugger
                    Auth.currentAuthenticatedUser()
                    .then(user => {
                        debugger
                        return Auth.changePassword(user, 'Temp@321', this.payload.password);
                    })
                    .then(data => {
                        signOut()//.then((data) => console.log('DONE', data)).catch((err) => console.log('SIGN OUT ERR', err));
                        this.$router.push({name: 'SuccessPage', params: {
                            title: 'Account Verified!',
                            subTitle: 'You have successfully updated the password',
                            icon:'far fa-check-circle'
                        }})
                    }
                        )
                    .catch(err => {
                        debugger
                    });
                })
                
            }
            else
            {
                this._showToast("User account is already verified.", { variant: 'danger',title:'Error' })
            }
            
        },
        verifyAccount() {
            accountServices.verifyAccount(this.payload).then(resp => {
                if(!resp.error) {
                    this.$router.push({name: 'SuccessPage', params: {
                        title: 'Account Verified!',
                        subTitle: 'You have successfully updated the password',
                        icon:'far fa-check-circle'
                    }})
                }
            })
        }
    }
}